<template>
  <div v-show="taskEnabled && tasksAvailable" :class="$style.field">
    <label :for="id">Link to Task</label>
    <span v-if="readonly" :class="$style.value">{{ value.subject }}</span>
    <multiselect
      v-else
      :id="id"
      v-model="value"
      label="subject"
      track-by="crmId"
      placeholder="Please select"
      :allow-empty="true"
      :show-labels="true"
      :options="tasks"
      select-label=""
      selected-label="✕"
      deselect-label="✕"
    >
      <template #noResult>
        <span>No matches found</span>
      </template>
      <template #option="props">
        <div class="primary">{{ props.option.subject }}</div>
        <div class="secondary" v-if="props.option.due">
          Due {{ formatDueDate(props.option.due) }}
        </div>
      </template>
    </multiselect>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import axios, { CancelToken } from "axios";
import moment from "moment";
import Multiselect from "vue-components/vue-multiselect";
import { createNamespacedHelpers } from "vuex";
import { errorNotification } from "../notifications";

const { mapState, mapGetters, mapMutations } =
  createNamespacedHelpers("activitySummary");
let cancellationSource;

export default {
  components: { Multiselect },
  data() {
    return {
      id: "crm_id",
      value: null,
      tasks: [],
      showError: false,
      readonly: false,
    };
  },
  computed: {
    ...mapGetters([
      "taskEnabled",
      "hasSelectedProspect",
      "hasSelectedOpportunity",
    ]),
    ...mapState([
      "activity",
      "formErrors",
      "selectedProspect",
      "selectedOpportunity",
    ]),
    tasksAvailable() {
      return this.tasks.length > 0;
    },
    error() {
      return this.formErrors[this.id];
    },
    pusherPrivateActivityChannel() {
      return `private-activity.${this.activity.id}`;
    },
  },
  watch: {
    value(option) {
      this.updateForm(option);
    },
    selectedProspect() {
      this.populateOptions();
    },
    selectedOpportunity() {
      this.populateOptions();
    },
  },
  beforeDestroy() {
    this.$pusher.unsubscribe(this.pusherPrivateActivityChannel);
  },
  created() {
    this.$_activitySummary_config.EventBus.$on(
      "ACTIVITY_FORM_SUBMITTED",
      () => {
        this.showError = true;
      }
    );

    if (this.taskEnabled) {
      this.populateOptions();
    }

    this.watchExternalUpdate();
  },
  methods: {
    ...mapMutations(["upsertFormData", "setSelectedTask"]),
    watchExternalUpdate() {
      const channel = this.$pusher.subscribe(this.pusherPrivateActivityChannel);

      channel.bind("activity.linked-to-crm", (task) => {
        this.readonly = true;
        this.value = task;
      });
    },
    updateForm(option) {
      this.showError = false;
      option = option || {};

      const taskId = option.crmId || null;
      const subject = option.subject || "";

      this.upsertFormData({
        id: this.id,
        value: taskId,
      });

      this.upsertFormData({
        id: "title",
        value: subject,
      });

      this.setSelectedTask(option);
    },
    populateOptions() {
      if (this.readonly) {
        return;
      }

      if (this.hasSelectedProspect && this.hasSelectedOpportunity) {
        this.retrieveTasks(
          this.selectedProspect.crmId,
          this.selectedProspect.type,
          this.selectedOpportunity.crmId
        );
      } else if (this.hasSelectedProspect) {
        this.retrieveTasks(
          this.selectedProspect.crmId,
          this.selectedProspect.type
        );
      }
    },
    formatDueDate(date) {
      return moment(date).fromNow();
    },
    retrieveTasks(prospectId, objectType, opportunityId) {
      if (cancellationSource) {
        cancellationSource.cancel();
      }
      cancellationSource = CancelToken.source();
      const params = {
        prospectId,
        objectType,
        ...(opportunityId && { opportunityId }),
      };

      return axios
        .get(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/crm/tasks`,
          {
            cancelToken: cancellationSource.token,
            params,
          }
        )
        .then((response) => (this.tasks = response.data))
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }

          console.error(error);
          errorNotification({
            message: error.response.data.error.message,
          }).show();
        });
    },
  },
};
</script>

<style module lang="less" src="../custom-section/fields/field.less"></style>



// WEBPACK FOOTER //
// select-task.vue?56967761